import { useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import Calling from "../../api/Calling";
import { useNavigate } from "react-router-dom";
import { FiUser, FiLock, FiEye, FiEyeOff, FiArrowRight, FiShield } from "react-icons/fi";
import img2 from '../../Image/logo.svg';

export default function Login() {
    const [loader, setLoader] = useState(false);
    const [adminId, setAdminId] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [focusedField, setFocusedField] = useState(null);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoader(true);
            const body = {
                a_id: adminId,
                a_password: password
            };
            const resp = await Calling.AdminLogin(body);
            const { status, token, message } = resp;
            if (status) {
                toast.success(message, {
                    autoClose: 2000,
                });
                setTimeout(() => {
                    localStorage.setItem("token", token);
                    navigate("/admin/panel/login/otp");
                    setLoader(false);
                }, 1000);
            } else {
                toast.error(message, {
                    autoClose: 2000,
                });
                setLoader(false);
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong. Please try again.", {
                autoClose: 2000,
            });
            setLoader(false);
        }
    };

    return (
        <>
            {loader && <Loader />}

            <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-main-blue via-emerald-500 to-teal-600 p-4 relative overflow-hidden">
                <title>Admin Login | Number Storage</title>

                {/* Background Decorations */}
                <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    <div className="absolute -top-40 -right-40 w-80 h-80 bg-white/10 rounded-full blur-3xl"></div>
                    <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-white/5 rounded-full blur-3xl"></div>
                </div>

                {/* Main Card */}
                <div className="relative z-10 w-full max-w-md">
                    
                    {/* Glass Card */}
                    <div className="bg-main-white rounded-3xl shadow-2xl overflow-hidden">
                        
                        {/* Header Section with Logo */}
                        <div className="px-8 text-center">
                            {/* Logo */}
                            <div className="inline-flex items-center justify-center">
                                <img src={img2} alt="Logo" className="w-24 h-24 object-contain" />
                            </div>
                        </div>

                        {/* Divider */}
                        <div className="mx-8 h-px bg-gradient-to-r from-transparent via-main-border to-transparent"></div>

                        {/* Form Section */}
                        <form onSubmit={handleSubmit} className="p-8 space-y-5">
                            
                            {/* Admin ID Field */}
                            <div>
                                <label htmlFor="AdminId" className="block text-sm font-semibold text-main-font mb-2">
                                    Admin ID
                                </label>
                                <div className={`relative rounded-xl border transition-all duration-200 bg-main-white ${
                                    focusedField === 'adminId' 
                                        ? 'border-main-blue shadow-md shadow-main-blue/20 ring-2 ring-main-blue/20' 
                                        : 'border-main-border hover:border-main-subfont'
                                }`}>
                                    <div className={`absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none`}>
                                        <div className={`w-9 h-9 rounded-lg flex items-center justify-center transition-all duration-200 ${
                                            focusedField === 'adminId' 
                                                ? 'bg-main-blue text-main-white' 
                                                : 'bg-main-th text-main-subfont'
                                        }`}>
                                            <FiUser className="h-4 w-4" />
                                        </div>
                                    </div>
                                    <input
                                        type="text"
                                        id="AdminId"
                                        value={adminId}
                                        onChange={(e) => setAdminId(e.target.value)}
                                        onFocus={() => setFocusedField('adminId')}
                                        onBlur={() => setFocusedField(null)}
                                        className="w-full pl-16 pr-4 py-4 bg-transparent text-main-font placeholder-main-subfont focus:outline-none text-sm rounded-xl"
                                        placeholder="Enter your admin ID"
                                        required
                                    />
                                </div>
                            </div>

                            {/* Password Field */}
                            <div>
                                <div className="flex items-center justify-between mb-2">
                                    <label htmlFor="password" className="block text-sm font-semibold text-main-font">
                                        Password
                                    </label>
                                    <button
                                        type="button"
                                        onClick={() => navigate('/admin/panel/forgetpw')}
                                        className="text-xs text-main-blue hover:text-emerald-600 font-medium transition-colors duration-200 hover:underline"
                                    >
                                        Forgot Password?
                                    </button>
                                </div>
                                <div className={`relative rounded-xl border transition-all duration-200 bg-main-white ${
                                    focusedField === 'password' 
                                        ? 'border-main-blue shadow-md shadow-main-blue/20 ring-2 ring-main-blue/20' 
                                        : 'border-main-border hover:border-main-subfont'
                                }`}>
                                    <div className={`absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none`}>
                                        <div className={`w-9 h-9 rounded-lg flex items-center justify-center transition-all duration-200 ${
                                            focusedField === 'password' 
                                                ? 'bg-main-blue text-main-white' 
                                                : 'bg-main-th text-main-subfont'
                                        }`}>
                                            <FiLock className="h-4 w-4" />
                                        </div>
                                    </div>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        id="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        onFocus={() => setFocusedField('password')}
                                        onBlur={() => setFocusedField(null)}
                                        className="w-full pl-16 pr-14 py-4 bg-transparent text-main-font placeholder-main-subfont focus:outline-none text-sm rounded-xl"
                                        placeholder="Enter your password"
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="absolute inset-y-0 right-0 pr-4 flex items-center text-main-subfont hover:text-main-font transition-colors duration-200"
                                    >
                                        {showPassword ? (
                                            <FiEyeOff className="h-5 w-5" />
                                        ) : (
                                            <FiEye className="h-5 w-5" />
                                        )}
                                    </button>
                                </div>
                            </div>

                            {/* Login Button */}
                            <button
                                type="submit"
                                disabled={loader}
                                className="w-full mt-3 bg-main-blue text-main-white py-4 px-6 rounded-xl font-semibold hover:bg-emerald-600 hover:shadow-lg hover:shadow-main-blue/30 focus:outline-none focus:ring-2 focus:ring-main-blue focus:ring-offset-2 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                            >
                                {loader ? (
                                    <>
                                        <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                        </svg>
                                        <span>Signing in...</span>
                                    </>
                                ) : (
                                    <>
                                        <span>Sign In</span>
                                        <FiArrowRight className="w-5 h-5" />
                                    </>
                                )}
                            </button>
                              {/* Footer outside card */}
                    <p className="text-center text-xs pt-2">
                        © {new Date().getFullYear()} Number Storage. All rights reserved.
                    </p>
                        </form>

                    </div>

                  
                </div>
            </div>
        </>
    );
}